import { useAdminUsers } from "@features/users/api";
import AdminUserDetailPage from "@pages/admin/user-detail";
import { getStoredUser } from "@shared/userStorage";
import { Alert, Skeleton } from "antd";
import { useMemo } from "react";
import { useSearchParams } from "react-router";

const SettingsProfilePage = () => {
  const [searchParams] = useSearchParams();
  const usersQuery = useAdminUsers();
  const explicitId = searchParams.get("id") ?? undefined;
  const storedSelf = getStoredUser();
  const fallbackId = useMemo(
    () => storedSelf?.id ?? usersQuery.data?.[0]?.id,
    [storedSelf?.id, usersQuery.data],
  );
  const profileUserId = explicitId ?? fallbackId;

  return usersQuery.isLoading && !profileUserId ? (
    <CardSkeleton />
  ) : profileUserId ? (
    <AdminUserDetailPage profileMode profileUserId={profileUserId} />
  ) : (
    <Alert
      type="warning"
      showIcon
      title="Профиль недоступен"
      description="Не удалось определить пользователя для редактирования. Обновите страницу или обратитесь к администратору."
    />
  );
};

const CardSkeleton = () => (
  <Skeleton
    active
    paragraph={{ rows: 8 }}
    title={{ width: "40%" }}
    style={{ background: "#fff", padding: 24, borderRadius: 12 }}
  />
);

export default SettingsProfilePage;
